import { render } from "./BrandImage.vue?vue&type=template&id=1569a800&scoped=true"
import script from "./BrandImage.vue?vue&type=script&lang=js"
export * from "./BrandImage.vue?vue&type=script&lang=js"

import "./BrandImage.vue?vue&type=style&index=0&id=1569a800&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.87.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1569a800"]])

export default __exports__